import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router";
import { Web3ContextProvider } from "react-dapp-web3";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import App from "./components/App";
import history from "./utils/history";
import "./utils/scripts/fontawesome";

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <Web3ContextProvider>
        <App />
      </Web3ContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
